// import { useNavigate } from "react-router-dom";
import logout from "../services/maestros.service";
// const Salir = () => {
//   logout.logout()
//   const navigate = useNavigate();
//   navigate("/login");
//   };

// export default Salir;

import React from "react";
import { useNavigate } from "react-router-dom";

const Logout = ({ onLogout }) => {
  const navigate = useNavigate();

  const handleLogout = () => {
    // Lógica de desautenticación aquí
    onLogout(); // Llama a la función de desautenticación en App.js
    logout.logout();
    navigate("/");
  };

  return (
    <div>
      <h1>Logout</h1>
      <p>¿Estás seguro de que deseas cerrar sesión?</p>
      <button onClick={handleLogout}>Logout</button>
    </div>
  );
};

export default Logout;
